import { CompetitionLanding } from './CompetitionLanding';
import type { FreeLimits } from '../types';

const config = {
  slug: 'copa-do-brasil',
  routeId: 'pool-copa-do-brasil',
  seoTitle: 'Bolão Copa do Brasil 2026 — Palpites Grátis | Bolão Elite',
  seoDescription:
    'Crie seu bolão da Copa do Brasil 2026 grátis. Torneio eliminatório com clubes de todo o Brasil, do Amazonas ao Rio Grande do Sul. Palpite nos placares, dispute com amigos e acompanhe o ranking em tempo real.',
  seoKeywords:
    'bolão copa do brasil, bolão copa do brasil 2026, palpites copa do brasil, bolão futebol eliminatório, copa do brasil online grátis, bolão copa do brasil com amigos',
  canonical: 'https://bolaoelite.com.br/bolao-copa-do-brasil',
  heroTitle: 'Bolão da Copa do Brasil 2026',
  heroSubtitle:
    'O torneio eliminatório mais emocionante do Brasil. De clubes do interior até os gigantes nacionais — cada jogo pode ser o último. Palpite e dispute com amigos.',
  accentColor: 'text-yellow-600',
  facts: [
    'Mais de 90 clubes de todos os estados brasileiros participam',
    'Formato eliminatório — um resultado decide o classificado',
    'Times pequenos x grandes: os maiores azarões do futebol brasileiro',
    'Jogo de ida e volta nas fases iniciais e semifinais',
    'Final em jogo único na fase decisiva',
    'Campeão garante vaga direta na Copa Libertadores',
  ],
  faqs: [
    {
      question: 'O bolão da Copa do Brasil é gratuito?',
      answer: (limits: FreeLimits) =>
        `O Bolão Elite tem plano gratuito e plano Premium. No gratuito você cria ${limits.maxPrivatePoolsCreated} bolão privado (Copa do Brasil, Brasileirão, Libertadores ou qualquer competição) e participa de até ${limits.maxPrivatePoolsJoined} como convidado, com até ${limits.maxPrivatePoolMembers} participantes cada. O Premium remove todas as restrições.`,
    },
    {
      question: 'Como funcionam os palpites na Copa do Brasil?',
      answer:
        'Você palpita no placar de cada jogo individualmente. Como o torneio é eliminatório, há jogos de ida e de volta em algumas fases. Cada partida tem seus próprios palpites e pontuação independente.',
    },
    {
      question: 'Posso fazer palpites mesmo com times desconhecidos?',
      answer:
        'Claro! A Copa do Brasil é justamente famosa pelas surpresas. Times pequenos do interior enfrentam os grandes — é a beleza do torneio. Você pode palpitar em todos os jogos cadastrados no sistema.',
    },
    {
      question: 'Quando os palpites são bloqueados?',
      answer:
        'Os palpites ficam disponíveis até o início de cada partida. Assim que o jogo começar, o sistema bloqueia automaticamente o palpite daquela partida.',
    },
    {
      question: 'Como são calculados os pontos?',
      answer:
        'Acertar o placar exato vale mais pontos. Acertar o vencedor ou empate também pontua conforme a regra escolhida ao criar o bolão (Regra A, B ou C). O criador do bolão define a regra antes de começar.',
    },
  ],
  jsonLd: {
    '@context': 'https://schema.org',
    '@type': 'SportsEvent',
    name: 'Copa do Brasil 2026',
    description:
      'A Copa do Brasil é o principal torneio eliminatório do futebol brasileiro, reunindo mais de 90 clubes de todos os estados do Brasil. O campeão garante vaga na Copa Libertadores da América.',
    sport: 'Soccer',
    url: 'https://bolaoelite.com.br/bolao-copa-do-brasil',
    organizer: { '@type': 'SportsOrganization', name: 'CBF — Confederação Brasileira de Futebol' },
    location: { '@type': 'Country', name: 'Brasil' },
    eventStatus: 'https://schema.org/EventScheduled',
    inLanguage: 'pt-BR',
  },
};

export default function LandingCopaDoBrasil() {
  return <CompetitionLanding config={config} />;
}
